<div class="view-controls-container">
  <!-- Group Dropdown -->
  <!-- <div class="control-dropdown">
  <button type="button" class="control-btn" (click)="toggleGroupMenu()">
    <i class="pi pi-layer-group"></i>
    <span>Group: {{ getGroupLabel() }}</span>
    <i class="pi pi-chevron-down"></i>
  </button>
  <div class="dropdown-menu" *ngIf="showGroupMenu" (click)="$event.stopPropagation()">
    <div class="dropdown-item"
      *ngFor="let option of groupOptions"
      [class.active]="currentGroupBy === option.value"
      (click)="onGroupSelect(option.value)">
      <i class="pi pi-check" *ngIf="currentGroupBy === option.value"></i>
      <span>{{ option.label }}</span>
    </div>
  </div>
</div> -->

<!-- Filter Button -->
<div class="control-dropdown">
  <button type="button" class="control-btn" (click)="toggleFilterMenu()">
    <i class="pi pi-filter"></i>
    <span>Filter</span>
    @if (getFilterCount() > 0) {
      <span class="badge">{{ getFilterCount() }}</span>
    }
  </button>
  @if (showFilterMenu) {
    <div class="filter-menu" (click)="$event.stopPropagation()">
      <div class="filter-menu-header">
        <h4>Filters</h4>
        @if (getFilterCount() > 0) {
          <button class="clear-all-btn" (click)="clearAllFilters()">
            Clear All
          </button>
        }
      </div>
      @if (activeFilters.length > 0) {
        <div class="active-filters">
          @for (filter of activeFilters; track filter) {
            <div class="active-filter-item">
              <span class="filter-label">{{ filter.label }}:</span>
              <span class="filter-value">
                @if (filter.type === 'text') {
                  <span>{{ filter.value }}</span>
                }
                @if (filter.type === 'multiselect') {
                  <span>{{ getMultiselectDisplay(filter) }}</span>
                }
                @if (filter.type === 'user') {
                  <span>{{ filter.value?.fullName || getUserLabel(filter.value) }}</span>
                }
                @if (filter.type === 'daterange') {
                  <span>{{ getDateRangeDisplay(filter) }}</span>
                }
              </span>
              <i class="pi pi-times" (click)="removeFilter(filter)"></i>
            </div>
          }
        </div>
      }
      <div class="filter-options">
        @for (filter of filterOptions; track filter) {
          <div class="filter-option">
            <label>{{ filter.label }}</label>
            <!-- Text Input -->
            @if (filter.type === 'text') {
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filter.value"
                (input)="onFilterChange(filter)"
                [placeholder]="'Enter ' + filter.label.toLowerCase()">
            }
            <!-- Multi Select -->
            @if (filter.type === 'multiselect') {
              <p-multiSelect
                appendTo="body"
                [filter]="true"
                [filterBy]="'name'"
                dropdownIcon="fa fa-caret-down"
                [options]="filter.options"
                [(ngModel)]="filter.value"
                (onChange)="onFilterChange(filter)"
                optionLabel="name"
                optionValue="value"
                [placeholder]="'Select ' + filter.label"
                [style]="{'width': '100%'}">
              </p-multiSelect>
            }
            <!-- User Select with Autocomplete -->
            @if (filter.type === 'user' && filter.field === 'assignedTo') {
              <app-user-search
                [selectedUser]="filter.value"
                (onUserSelected)="onUserSelected($event, filter)"
                (onUserClearedEvent)="onUserCleared($event, filter)"
                [showCreateUser]="false"
                [forSearchBar]="false">
              </app-user-search>
            }
            <!-- User Select Dropdown (for createdBy and requestedBy - keeping dropdown for now) -->
            @if (filter.type === 'user' && filter.field !== 'assignedTo') {
              <p-dropdown
                [options]="users"
                appendTo="body"
                [filter]="true"
                [filterBy]="'fullName'"
                dropdownIcon="fa fa-caret-down"
                [(ngModel)]="filter.value"
                (onChange)="onFilterChange(filter)"
                [optionLabel]="'fullName'"
                [dataKey]="'userId'"
                [placeholder]="'Select ' + filter.label"
                [showClear]="true"
                [style]="{'width': '100%'}">
              </p-dropdown>
            }
            <!-- Date Range -->
            @if (filter.type === 'daterange') {
              <p-calendar
                appendTo="body"
                [(ngModel)]="filter.value"
                (onClose)="onFilterChange(filter)"
                selectionMode="range"
                [placeholder]="'Select date range'"
                [style]="{'width': '100%'}">
              </p-calendar>
            }
          </div>
        }
      </div>
    </div>
  }
</div>

<!-- Columns Button -->
<!-- <div class="control-dropdown">
<button type="button" class="control-btn" (click)="toggleColumnsMenu()">
  <i class="pi pi-bars"></i>
  <span>Columns</span>
</button>
<div class="dropdown-menu columns-menu" *ngIf="showColumnsMenu" (click)="$event.stopPropagation()">
  <div class="dropdown-item"
    *ngFor="let column of currentColumns"
    (click)="onColumnToggle(column)">
    <i class="pi" [class.pi-check]="column.visible !== false" [class.pi-times]="column.visible === false"></i>
    <span>{{ column.header }}</span>
  </div>
  <div class="dropdown-item" *ngIf="!currentColumns || currentColumns.length === 0">
    <span>No columns available</span>
  </div>
</div>
</div> -->
</div>

